import * as React from "react";
function SvgTorusWalletCircleIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width="40" height="40" rx="20" fill="#0364FF" />
            <path d="M21.9758 10H10V15.9259H21.9758V10Z" fill="white" />
            <path d="M21.9758 10H15.5886V30H21.9757L21.9758 10Z" fill="white" />
            <path d="M26.766 15.9259C28.5297 15.9259 29.9595 14.5994 29.9595 12.963C29.9595 11.3266 28.5297 10 26.766 10C25.0023 10 23.5725 11.3266 23.5725 12.963C23.5725 14.5994 25.0023 15.9259 26.766 15.9259Z" fill="white" />
        </svg>;
}
export default SvgTorusWalletCircleIcon;